module.exports = __webpack_public_path__ + "img/logo.e8cf79a2.png";